import { useReportLogo } from "@/lib/useLogo";

export function ReportLogo({ className = "h-6 max-w-[64px] sm:h-10 sm:max-w-[160px]", testId = "report-logo" }) {
  const logo = useReportLogo();
  if (!logo?.data) return null;
  return (
    <div className="inline-flex shrink-0 items-center rounded-md bg-white px-2 py-1" data-testid={testId}>
      <img src={logo.data} alt="Logo da empresa" className={`${className} w-auto object-contain`} />
    </div>
  );
}
